import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-630c899a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "instrumentos-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "instrumentos-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header-info" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Instrumentos de Pago"),
    /*#__PURE__*/ _createElementVNode("p", { class: "subtitle" }, "Gestiona las monedas y métodos de pago del sistema")
], -1 /* HOISTED */));
const _hoisted_6 = { class: "header-actions" };
const _hoisted_7 = { class: "tab-controls" };
const _hoisted_8 = {
    key: 0,
    class: "data-grid"
};
const _hoisted_9 = { class: "card-header" };
const _hoisted_10 = { class: "method-icon" };
const _hoisted_11 = { class: "card-title" };
const _hoisted_12 = { class: "method-badge" };
const _hoisted_13 = { class: "card-actions" };
const _hoisted_14 = ["onClick", "title"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "card-body" };
const _hoisted_18 = { class: "info-row" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "label" }, "Moneda:", -1 /* HOISTED */));
const _hoisted_20 = { class: "value" };
const _hoisted_21 = {
    key: 0,
    class: "info-row"
};
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "label" }, "Banco:", -1 /* HOISTED */));
const _hoisted_23 = { class: "value" };
const _hoisted_24 = {
    key: 1,
    class: "info-row"
};
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "label" }, "Titular:", -1 /* HOISTED */));
const _hoisted_26 = { class: "value" };
const _hoisted_27 = {
    key: 2,
    class: "info-row"
};
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "label" }, "N° Cuenta:", -1 /* HOISTED */));
const _hoisted_29 = { class: "value" };
const _hoisted_30 = {
    key: 1,
    class: "data-grid"
};
const _hoisted_31 = { class: "card-avatar" };
const _hoisted_32 = { class: "moneda-info" };
const _hoisted_33 = { class: "moneda-actions" };
const _hoisted_34 = ["onClick", "title"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
    key: 2,
    class: "loading-state"
};
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Cargando información...", -1 /* HOISTED */));
const _hoisted_39 = { class: "modal-window" };
const _hoisted_40 = { class: "modal-header" };
const _hoisted_41 = { class: "modal-title-group" };
const _hoisted_42 = { class: "modal-title" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "modal-subtitle" }, "Identifica los parámetros según el método seleccionado", -1 /* HOISTED */));
const _hoisted_44 = { class: "modal-body" };
const _hoisted_45 = { class: "form-grid-2" };
const _hoisted_46 = { class: "form-group" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Nombre Identificador "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_48 = { class: "form-group" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Moneda "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione moneda...", -1 /* HOISTED */));
const _hoisted_51 = ["value"];
const _hoisted_52 = { class: "form-group full-width" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Método de Pago "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione método...", -1 /* HOISTED */));
const _hoisted_55 = ["value"];
const _hoisted_56 = {
    key: 0,
    class: "form-group"
};
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Banco / Institución", -1 /* HOISTED */));
const _hoisted_58 = {
    key: 1,
    class: "form-group"
};
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre del Titular", -1 /* HOISTED */));
const _hoisted_60 = {
    key: 2,
    class: "form-group"
};
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número de Cuenta / Identificador", -1 /* HOISTED */));
const _hoisted_62 = {
    key: 3,
    class: "form-group"
};
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Cédula / RIF", -1 /* HOISTED */));
const _hoisted_64 = {
    key: 4,
    class: "form-group"
};
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo de Cuenta", -1 /* HOISTED */));
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "CORRIENTE" }, "Corriente", -1 /* HOISTED */));
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "AHORRO" }, "Ahorro", -1 /* HOISTED */));
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "HOT_WALLET" }, "Hot Wallet", -1 /* HOISTED */));
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "COLD_WALLET" }, "Cold Wallet", -1 /* HOISTED */));
const _hoisted_70 = [
    _hoisted_66,
    _hoisted_67,
    _hoisted_68,
    _hoisted_69
];
const _hoisted_71 = {
    key: 5,
    class: "form-group"
};
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Correo Electrónico", -1 /* HOISTED */));
const _hoisted_73 = {
    key: 6,
    class: "form-group"
};
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "N° de Teléfono", -1 /* HOISTED */));
const _hoisted_75 = {
    key: 7,
    class: "form-group"
};
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Modelo de Equipo", -1 /* HOISTED */));
const _hoisted_77 = {
    key: 8,
    class: "form-group"
};
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "N° Terminal", -1 /* HOISTED */));
const _hoisted_79 = {
    key: 9,
    class: "form-group"
};
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "N° SIM Card", -1 /* HOISTED */));
const _hoisted_81 = {
    key: 10,
    class: "form-group"
};
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Dirección Wallet / ID", -1 /* HOISTED */));
const _hoisted_83 = {
    key: 11,
    class: "form-group"
};
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Identificador de Caja", -1 /* HOISTED */));
const _hoisted_85 = { class: "modal-footer" };
const _hoisted_86 = ["disabled"];
const _hoisted_87 = { class: "modal-window modal-small" };
const _hoisted_88 = { class: "modal-header" };
const _hoisted_89 = { class: "modal-title-group" };
const _hoisted_90 = { class: "modal-title" };
const _hoisted_91 = {
    key: 0,
    class: "modal-subtitle"
};
const _hoisted_92 = { class: "modal-body" };
const _hoisted_93 = { class: "form-group" };
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre de la Moneda", -1 /* HOISTED */));
const _hoisted_95 = { class: "form-group" };
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Símbolo", -1 /* HOISTED */));
const _hoisted_97 = { class: "modal-footer" };
const _hoisted_98 = ["disabled"];
import { ref, onMounted } from 'vue';
import Header from '@/components/HeaderDashboard.vue';
import Sidebar from '@/components/Sidebar.vue';
import { InstrumentoPagoService } from '@/services/InstrumentoPagoService';
import { PlusIcon, EditIcon, TrashIcon, PowerIcon, XIcon, Loader2Icon, CoinsIcon, CreditCardIcon, ArrowRightLeftIcon, WalletIcon, SmartphoneIcon, BanknoteIcon } from 'lucide-vue-next';
import Swal from 'sweetalert2';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const activeTab = ref('instrumentos');
        const loading = ref(true);
        const saving = ref(false);
        const instrumentos = ref([]);
        const monedas = ref([]);
        const isModalOpen = ref(false);
        const isEditing = ref(false);
        const form = ref({
            instrumentoPagoId: 0,
            nombre: '',
            metodo: '',
            monedaId: '',
            banco: '',
            titular: '',
            numeroCuenta: '',
            numeroIdentificacion: '',
            tipoCuenta: 'CORRIENTE',
            email: '',
            telefono: '',
            modeloEquipo: '',
            numeroTerminal: '',
            numeroSIM: '',
            direccionID: '',
            nombreCaja: '',
            activo: true
        });
        const isModalMonedaOpen = ref(false);
        const isEditingMoneda = ref(false);
        const monedaForm = ref({
            monedaId: 0,
            nombre: '',
            simbolo: '',
            activo: true
        });
        const metodosDisponibles = [
            'EFECTIVO', 'TRANSFERENCIA', 'ZELLE', 'PAGOMOVIL', 'BIOPAGO',
            'WALLET', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL', 'DEPOSITO'
        ];
        const loadData = async () => {
            loading.value = true;
            try {
                const [monedasRes, instrumentosRes] = await Promise.all([
                    InstrumentoPagoService.getMonedas(),
                    InstrumentoPagoService.getInstrumentos()
                ]);
                monedas.value = monedasRes.datos || [];
                instrumentos.value = instrumentosRes.datos || [];
            }
            catch (error) {
                console.error(error);
            }
            finally {
                loading.value = false;
            }
        };
        const openModal = (item = null) => {
            if (activeTab.value === 'monedas') {
                openModalMoneda();
                return;
            }
            if (item) {
                isEditing.value = true;
                form.value = { ...item };
            }
            else {
                isEditing.value = false;
                form.value = {
                    instrumentoPagoId: 0,
                    nombre: '',
                    metodo: '',
                    monedaId: '',
                    banco: '',
                    titular: '',
                    numeroCuenta: '',
                    numeroIdentificacion: '',
                    tipoCuenta: 'CORRIENTE',
                    email: '',
                    telefono: '',
                    modeloEquipo: '',
                    numeroTerminal: '',
                    numeroSIM: '',
                    direccionID: '',
                    nombreCaja: '',
                    activo: true
                };
            }
            isModalOpen.value = true;
        };
        const openModalMoneda = (item = null) => {
            if (item) {
                isEditingMoneda.value = true;
                monedaForm.value = { ...item };
            }
            else {
                isEditingMoneda.value = false;
                monedaForm.value = { monedaId: 0, nombre: '', simbolo: '', activo: true };
            }
            isModalMonedaOpen.value = true;
        };
        const showField = (field) => {
            const method = form.value.metodo;
            if (!method)
                return false;
            switch (field) {
                case 'banco':
                    return ['TRANSFERENCIA', 'ZELLE', 'PAGOMOVIL', 'BIOPAGO', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL', 'DEPOSITO'].includes(method);
                case 'titular':
                    return method !== 'EFECTIVO';
                case 'numeroCuenta':
                    return method !== 'EFECTIVO';
                case 'numeroIdentificacion':
                    return ['TRANSFERENCIA', 'PAGOMOVIL', 'BIOPAGO', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL', 'DEPOSITO'].includes(method);
                case 'tipoCuenta':
                    return method !== 'EFECTIVO' && method !== 'PAGOMOVIL';
                case 'email':
                    return ['ZELLE', 'WALLET'].includes(method);
                case 'telefono':
                    return ['ZELLE', 'PAGOMOVIL', 'BIOPAGO', 'WALLET', 'DATAFONO_FISICO'].includes(method);
                case 'modeloEquipo':
                    return ['BIOPAGO', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL'].includes(method);
                case 'numeroTerminal':
                    return ['DATAFONO_FISICO', 'DATAFONO_VIRTUAL'].includes(method);
                case 'numeroSIM':
                    return method === 'DATAFONO_FISICO';
                case 'direccionID':
                    return method === 'WALLET';
                case 'nombreCaja':
                    return method === 'EFECTIVO';
                default:
                    return false;
            }
        };
        const saveInstrumento = async () => {
            saving.value = true;
            try {
                let res;
                if (isEditing.value) {
                    res = await InstrumentoPagoService.updateInstrumento(form.value.instrumentoPagoId, form.value);
                }
                else {
                    res = await InstrumentoPagoService.createInstrumento(form.value);
                }
                if (res.exito) {
                    Swal.fire('¡Éxito!', 'Instrumento guardado correctamente', 'success');
                    isModalOpen.value = false;
                    loadData();
                }
            }
            catch (error) {
                Swal.fire('Error', 'No se pudo guardar el instrumento', 'error');
            }
            finally {
                saving.value = false;
            }
        };
        const saveMoneda = async () => {
            saving.value = true;
            try {
                let res;
                if (isEditingMoneda.value) {
                    res = await InstrumentoPagoService.updateMoneda(monedaForm.value.monedaId, monedaForm.value);
                }
                else {
                    res = await InstrumentoPagoService.createMoneda(monedaForm.value);
                }
                if (res.exito) {
                    Swal.fire('¡Éxito!', 'Moneda guardada correctamente', 'success');
                    isModalMonedaOpen.value = false;
                    loadData();
                }
            }
            catch (error) {
                Swal.fire('Error', 'No se pudo guardar la moneda', 'error');
            }
            finally {
                saving.value = false;
            }
        };
        const toggleStatus = async (item) => {
            try {
                const res = await InstrumentoPagoService.toggleStatus(item.instrumentoPagoId);
                if (res.exito) {
                    item.activo = res.datos;
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        const toggleMonedaStatus = async (item) => {
            try {
                const res = await InstrumentoPagoService.toggleMonedaStatus(item.monedaId);
                if (res.exito) {
                    item.activo = res.datos;
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        const confirmDeleteInstrumento = async (id) => {
            const result = await Swal.fire({
                title: '¿Eliminar Instrumento?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33'
            });
            if (result.isConfirmed) {
                await InstrumentoPagoService.deleteInstrumento(id);
                loadData();
            }
        };
        const confirmDeleteMoneda = async (id) => {
            const result = await Swal.fire({
                title: '¿Eliminar Moneda?',
                text: 'Afectará a los instrumentos asociados',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33'
            });
            if (result.isConfirmed) {
                const res = await InstrumentoPagoService.deleteMoneda(id);
                if (res.exito) {
                    loadData();
                }
            }
        };
        onMounted(() => {
            loadData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Sidebar),
                    _createElementVNode("main", _hoisted_3, [
                        _createCommentVNode(" Cabecera "),
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _createCommentVNode(" Pestañas de Navegación "),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("button", {
                                        onClick: _cache[0] || (_cache[0] = ($event) => (activeTab.value = 'instrumentos')),
                                        class: _normalizeClass([{ active: activeTab.value === 'instrumentos' }, "tab-btn"])
                                    }, " Instrumentos ", 2 /* CLASS */),
                                    _createElementVNode("button", {
                                        onClick: _cache[1] || (_cache[1] = ($event) => (activeTab.value = 'monedas')),
                                        class: _normalizeClass([{ active: activeTab.value === 'monedas' }, "tab-btn"])
                                    }, " Monedas ", 2 /* CLASS */)
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[2] || (_cache[2] = ($event) => (openModal())),
                                    class: "btn btn-primary"
                                }, [
                                    _createVNode(_unref(PlusIcon), { size: 18 }),
                                    _createTextVNode(" " + _toDisplayString(activeTab.value === 'monedas' ? 'Nueva Moneda' : 'Nuevo Instrumento'), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _createCommentVNode(" Vista de Instrumentos "),
                        (activeTab.value === 'instrumentos' && !loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instrumentos.value, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.instrumentoPagoId,
                                        class: _normalizeClass(["instrumento-card", { inactive: !item.activo }])
                                    }, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", _hoisted_10, [
                                                (item.metodo === 'EFECTIVO')
                                                    ? (_openBlock(), _createBlock(_unref(CoinsIcon), {
                                                        key: 0,
                                                        size: 24,
                                                        color: "#10b981"
                                                    }))
                                                    : (item.metodo === 'TRANSFERENCIA')
                                                        ? (_openBlock(), _createBlock(_unref(ArrowRightLeftIcon), {
                                                            key: 1,
                                                            size: 24,
                                                            color: "#3b82f6"
                                                        }))
                                                        : (item.metodo?.includes('DATAFONO'))
                                                            ? (_openBlock(), _createBlock(_unref(CreditCardIcon), {
                                                                key: 2,
                                                                size: 24,
                                                                color: "#f59e0b"
                                                            }))
                                                            : (item.metodo === 'WALLET')
                                                                ? (_openBlock(), _createBlock(_unref(WalletIcon), {
                                                                    key: 3,
                                                                    size: 24,
                                                                    color: "#8b5cf6"
                                                                }))
                                                                : (item.metodo === 'PAGOMOVIL')
                                                                    ? (_openBlock(), _createBlock(_unref(SmartphoneIcon), {
                                                                        key: 4,
                                                                        size: 24,
                                                                        color: "#ef4444"
                                                                    }))
                                                                    : (_openBlock(), _createBlock(_unref(BanknoteIcon), {
                                                                        key: 5,
                                                                        size: 24,
                                                                        color: "#64748b"
                                                                    }))
                                            ]),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("h3", null, _toDisplayString(item.nombre), 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_12, _toDisplayString(item.metodo || 'S/M'), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (toggleStatus(item)),
                                                    class: "btn-icon",
                                                    title: item.activo ? 'Desactivar' : 'Activar'
                                                }, [
                                                    _createVNode(_unref(PowerIcon), {
                                                        size: 16,
                                                        class: _normalizeClass(item.activo ? 'text-success' : 'text-danger')
                                                    }, null, 8 /* PROPS */, ["class"])
                                                ], 8 /* PROPS */, _hoisted_14),
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (openModal(item)),
                                                    class: "btn-icon text-primary",
                                                    title: "Editar"
                                                }, [
                                                    _createVNode(_unref(EditIcon), { size: 16 })
                                                ], 8 /* PROPS */, _hoisted_15),
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (confirmDeleteInstrumento(item.instrumentoPagoId)),
                                                    class: "btn-icon text-danger",
                                                    title: "Eliminar"
                                                }, [
                                                    _createVNode(_unref(TrashIcon), { size: 16 })
                                                ], 8 /* PROPS */, _hoisted_16)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, [
                                                _hoisted_19,
                                                _createElementVNode("span", _hoisted_20, _toDisplayString(item.monedaNombre) + " (" + _toDisplayString(item.monedaSimbolo) + ")", 1 /* TEXT */)
                                            ]),
                                            (item.banco)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _hoisted_22,
                                                    _createElementVNode("span", _hoisted_23, _toDisplayString(item.banco), 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            (item.titular)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                    _hoisted_25,
                                                    _createElementVNode("span", _hoisted_26, _toDisplayString(item.titular), 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            (item.numeroCuenta)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _hoisted_28,
                                                    _createElementVNode("span", _hoisted_29, _toDisplayString(item.numeroCuenta), 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Vista de Monedas "),
                        (activeTab.value === 'monedas' && !loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monedas.value, (moneda) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: moneda.monedaId,
                                        class: _normalizeClass(["moneda-card", { inactive: !moneda.activo }])
                                    }, [
                                        _createElementVNode("div", _hoisted_31, _toDisplayString(moneda.simbolo || '$'), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("h3", null, _toDisplayString(moneda.nombre), 1 /* TEXT */),
                                            _createElementVNode("p", null, "Símbolo: " + _toDisplayString(moneda.simbolo), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => (toggleMonedaStatus(moneda)),
                                                class: "btn-icon",
                                                title: moneda.activo ? 'Desactivar' : 'Activar'
                                            }, [
                                                _createVNode(_unref(PowerIcon), {
                                                    size: 16,
                                                    class: _normalizeClass(moneda.activo ? 'text-success' : 'text-danger')
                                                }, null, 8 /* PROPS */, ["class"])
                                            ], 8 /* PROPS */, _hoisted_34),
                                            _createElementVNode("button", {
                                                onClick: ($event) => (openModalMoneda(moneda)),
                                                class: "btn-icon"
                                            }, [
                                                _createVNode(_unref(EditIcon), { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_35),
                                            _createElementVNode("button", {
                                                onClick: ($event) => (confirmDeleteMoneda(moneda.monedaId)),
                                                class: "btn-icon text-danger"
                                            }, [
                                                _createVNode(_unref(TrashIcon), { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_36)
                                        ])
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createVNode(_unref(Loader2Icon), {
                                    size: 48,
                                    class: "spinner"
                                }),
                                _hoisted_38
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" Modal Instrumentos "),
                    _createVNode(_Transition, { name: "modal-fade" }, {
                        default: _withCtx(() => [
                            (isModalOpen.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "modal-overlay",
                                    onClick: _cache[20] || (_cache[20] = _withModifiers(($event) => (isModalOpen.value = false), ["self"]))
                                }, [
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("div", _hoisted_41, [
                                                _createElementVNode("div", {
                                                    class: "icon-bg",
                                                    style: _normalizeStyle({ background: isEditing.value ? '#fff7ed' : '#eff6ff', color: isEditing.value ? '#f59e0b' : '#3b82f6' })
                                                }, [
                                                    (isEditing.value)
                                                        ? (_openBlock(), _createBlock(_unref(EditIcon), {
                                                            key: 0,
                                                            size: 20
                                                        }))
                                                        : (_openBlock(), _createBlock(_unref(PlusIcon), {
                                                            key: 1,
                                                            size: 20
                                                        }))
                                                ], 4 /* STYLE */),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("h2", _hoisted_42, _toDisplayString(isEditing.value ? `Editar Instrumento` : `Nuevo Instrumento de
                                        Pago`), 1 /* TEXT */),
                                                    _hoisted_43
                                                ])
                                            ]),
                                            _createElementVNode("button", {
                                                onClick: _cache[3] || (_cache[3] = ($event) => (isModalOpen.value = false)),
                                                class: "btn-close-modal"
                                            }, [
                                                _createVNode(_unref(XIcon), { size: 22 })
                                            ])
                                        ]),
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(saveInstrumento, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("div", _hoisted_45, [
                                                    _createElementVNode("div", _hoisted_46, [
                                                        _hoisted_47,
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.value.nombre) = $event)),
                                                            type: "text",
                                                            class: "form-control",
                                                            placeholder: "Ej: Banesco Corriente, Zelle Admin",
                                                            required: ""
                                                        }, null, 512 /* NEED_PATCH */), [
                                                            [_vModelText, form.value.nombre]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_48, [
                                                        _hoisted_49,
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.value.monedaId) = $event)),
                                                            class: "form-control form-select",
                                                            required: ""
                                                        }, [
                                                            _hoisted_50,
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monedas.value, (m) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    key: m.monedaId,
                                                                    value: m.monedaId
                                                                }, _toDisplayString(m.nombre) + " (" + _toDisplayString(m.simbolo) + ") ", 9 /* TEXT, PROPS */, _hoisted_51));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vModelSelect, form.value.monedaId]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_52, [
                                                        _hoisted_53,
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.value.metodo) = $event)),
                                                            class: "form-control form-select",
                                                            required: ""
                                                        }, [
                                                            _hoisted_54,
                                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(metodosDisponibles, (m) => {
                                                                return _createElementVNode("option", {
                                                                    key: m,
                                                                    value: m
                                                                }, _toDisplayString(m), 9 /* TEXT, PROPS */, _hoisted_55);
                                                            }), 64 /* STABLE_FRAGMENT */))
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vModelSelect, form.value.metodo]
                                                        ])
                                                    ]),
                                                    _createCommentVNode(" Campos Dinámicos "),
                                                    (showField('banco'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                            _hoisted_57,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.value.banco) = $event)),
                                                                type: "text",
                                                                class: "form-control",
                                                                placeholder: "Banesco, Mercantil, etc."
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.banco]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('titular'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                            _hoisted_59,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((form.value.titular) = $event)),
                                                                type: "text",
                                                                class: "form-control",
                                                                placeholder: "Nombre Completo o Empresa"
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.titular]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('numeroCuenta'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                            _hoisted_61,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.value.numeroCuenta) = $event)),
                                                                type: "text",
                                                                class: "form-control",
                                                                placeholder: "0123..."
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.numeroCuenta]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('numeroIdentificacion'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                            _hoisted_63,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.value.numeroIdentificacion) = $event)),
                                                                type: "text",
                                                                class: "form-control",
                                                                placeholder: "V-12345678"
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.numeroIdentificacion]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('tipoCuenta'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                            _hoisted_65,
                                                            _withDirectives(_createElementVNode("select", {
                                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.value.tipoCuenta) = $event)),
                                                                class: "form-control form-select"
                                                            }, _hoisted_70, 512 /* NEED_PATCH */), [
                                                                [_vModelSelect, form.value.tipoCuenta]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('email'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                            _hoisted_72,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((form.value.email) = $event)),
                                                                type: "email",
                                                                class: "form-control",
                                                                placeholder: "ejemplo@correo.com"
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.email]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('telefono'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                                            _hoisted_74,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((form.value.telefono) = $event)),
                                                                type: "text",
                                                                class: "form-control",
                                                                placeholder: "+58..."
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.telefono]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('modeloEquipo'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                            _hoisted_76,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((form.value.modeloEquipo) = $event)),
                                                                type: "text",
                                                                class: "form-control",
                                                                placeholder: "Verifone, etc."
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.modeloEquipo]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('numeroTerminal'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                            _hoisted_78,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((form.value.numeroTerminal) = $event)),
                                                                type: "text",
                                                                class: "form-control"
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.numeroTerminal]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('numeroSIM'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                            _hoisted_80,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((form.value.numeroSIM) = $event)),
                                                                type: "text",
                                                                class: "form-control"
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.numeroSIM]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('direccionID'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                                            _hoisted_82,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((form.value.direccionID) = $event)),
                                                                type: "text",
                                                                class: "form-control"
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.direccionID]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    (showField('nombreCaja'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                                            _hoisted_84,
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((form.value.nombreCaja) = $event)),
                                                                type: "text",
                                                                class: "form-control",
                                                                placeholder: "Caja Principal, Caja USD, etc."
                                                            }, null, 512 /* NEED_PATCH */), [
                                                                [_vModelText, form.value.nombreCaja]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_85, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: _cache[19] || (_cache[19] = ($event) => (isModalOpen.value = false)),
                                                    class: "btn-cancel-modal"
                                                }, "Cancelar"),
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    class: "btn-save-modal",
                                                    disabled: saving.value
                                                }, _toDisplayString(saving.value ? 'Guardando...' : 'Guardar Instrumento'), 9 /* TEXT, PROPS */, _hoisted_86)
                                            ])
                                        ], 32 /* NEED_HYDRATION */)
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" Modal Moneda "),
                    _createVNode(_Transition, { name: "modal-fade" }, {
                        default: _withCtx(() => [
                            (isModalMonedaOpen.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "modal-overlay",
                                    onClick: _cache[25] || (_cache[25] = _withModifiers(($event) => (isModalMonedaOpen.value = false), ["self"]))
                                }, [
                                    _createElementVNode("div", _hoisted_87, [
                                        _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("div", _hoisted_89, [
                                                _createElementVNode("div", {
                                                    class: "icon-bg",
                                                    style: _normalizeStyle({ background: isEditingMoneda.value ? '#fff7ed' : '#f0fdf4', color: isEditingMoneda.value ? '#f59e0b' : '#22c55e' })
                                                }, [
                                                    (isEditingMoneda.value)
                                                        ? (_openBlock(), _createBlock(_unref(EditIcon), {
                                                            key: 0,
                                                            size: 20
                                                        }))
                                                        : (_openBlock(), _createBlock(_unref(PlusIcon), {
                                                            key: 1,
                                                            size: 20
                                                        }))
                                                ], 4 /* STYLE */),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("h2", _hoisted_90, _toDisplayString(isEditingMoneda.value ? 'Editar Moneda' : 'Nueva Moneda'), 1 /* TEXT */),
                                                    (!isEditingMoneda.value)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_91, "Agrega una divisa al sistema"))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ]),
                                            _createElementVNode("button", {
                                                onClick: _cache[21] || (_cache[21] = ($event) => (isModalMonedaOpen.value = false)),
                                                class: "btn-close-modal"
                                            }, [
                                                _createVNode(_unref(XIcon), { size: 22 })
                                            ])
                                        ]),
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(saveMoneda, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_92, [
                                                _createElementVNode("div", _hoisted_93, [
                                                    _hoisted_94,
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((monedaForm.value.nombre) = $event)),
                                                        type: "text",
                                                        class: "form-control",
                                                        placeholder: "Dolares, Bolivares...",
                                                        required: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, monedaForm.value.nombre]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_95, [
                                                    _hoisted_96,
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((monedaForm.value.simbolo) = $event)),
                                                        type: "text",
                                                        class: "form-control",
                                                        placeholder: "$, Bs, etc.",
                                                        required: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, monedaForm.value.simbolo]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_97, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: _cache[24] || (_cache[24] = ($event) => (isModalMonedaOpen.value = false)),
                                                    class: "btn-cancel-modal"
                                                }, "Cancelar"),
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    class: "btn-save-modal",
                                                    disabled: saving.value
                                                }, "Guardar", 8 /* PROPS */, _hoisted_98)
                                            ])
                                        ], 32 /* NEED_HYDRATION */)
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
